import { APAR_SETUP, UKG_INVOICES, APAR_REPORT } from "../../types";

const APARComparisonReducer = (state = {}, action) => {
    if ([APAR_SETUP, UKG_INVOICES, APAR_REPORT].includes(action.type)) {
        state = { ...state, [action.type]: action.payload }
    };
    return state;
};

export default APARComparisonReducer;